import axiosClient from '../../configs/axios';


class DepotMasterService {
    // Get list 
    async getDepotList(params) {
        try {
            const response = await axiosClient.get(
                `/depot/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addDepot(data) {
        try {
            const response = await axiosClient.post('/depot/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteDepot(data) {
        try {
            const response = await axiosClient.put(`/depot/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new DepotMasterService(); 